// cSpell:enableCompoundWords

export const AppRoutes = {
  Home: '/',
  Auth: '/auth',
  CategoryRankings: '/rankings',
  Comparison: '/comparison',
  Forgot: 'resetpassword',
  GameDetails: '/gamedetails',
  HeadToHead: '/headtohead',
  Login: 'login',
  Logout: '/logout',
  Register: 'register',
  Standings: '/standings',
  Team: '/team',
  TeamStats: '/teamstats',
  ViewTeam: '/viewteam',
  WeeklyGames: '/weeklygames',

  // Lobby: '/lobby',
  // Join: 'join',
  // Resume: 'resume',
  // CreateGame: 'creategame',
  // Completed: 'completed',
  // Game: '/game/:gameId',
  // User: '/users/:userUid',

  // getGameRoute: (gameId: SqGameID) => SqRoutes.Game.replace(':gameId', gameId),
  // getUserRoute: (userUid: string) => SqRoutes.User.replace(':userUid', userUid),
} as const;

export type AppRoutesType = (typeof AppRoutes)[keyof typeof AppRoutes];

// #region FIRESTORE ACTIONS **************************************************
const AdminActionsBase = 'adminactions';
export const AdminActionsRoute = {
  baseRoute: AdminActionsBase,
  loadSchedule: `${AdminActionsBase}/loadSchedule`,
  loadGameScore: `${AdminActionsBase}/loadGameScore`,
  loadStandings: `${AdminActionsBase}/loadStandings`,
  loadRankings: `${AdminActionsBase}/loadRankings`,
};
// #endregion
